import { render, staticRenderFns } from "./LoginDealFreeze.vue?vue&type=template&id=5b183b94&scoped=true&"
import script from "./LoginDealFreeze.vue?vue&type=script&lang=js&"
export * from "./LoginDealFreeze.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealFreeze.vue?vue&type=style&index=0&id=5b183b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b183b94",
  null
  
)

export default component.exports